import { api } from "./client";

export interface KnowledgeAnswer {
  answer: string | null;
  sources: Array<{
    title: string;
    category: string;
    content?: string;
  }>;
  model?: string | null;
  message?: string;
}

export const knowledgeApi = {
  /** Ask a question about SIMSY and get an AI-generated answer. */
  ask: (question: string) =>
    api.post<{ data: KnowledgeAnswer }>("/knowledge/ask", { question }),

  /** Search knowledge base chunks directly (no LLM). */
  search: (q: string, limit = 5) =>
    api.get<{
      data: Array<{
        id: string;
        title: string;
        category: string;
        subcategory: string;
        content: string;
      }>;
    }>(`/knowledge/search?q=${encodeURIComponent(q)}&limit=${limit}`),
};
